import { RootState } from 'duck/store'
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { getPeopleArray } from 'scenes/Dashboard/data/people/selectors'
import { Person } from 'scenes/Dashboard/data/people/types'

import { Paper, Table, TableBody, TableHead, TablePagination } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

import { openPersonForm, updateCurrentPage } from '../../duck/actions'
import { getSearchParams } from '../../duck/selectors'
import { PersonRow } from './components/PersonRow'
import styles from './PeopleTable.style'

export class PeopleTable extends React.PureComponent<PeopleTableProps & WithStyles<typeof styles>> {
  render() {
    const { classes, people, selectPerson, limit, currentPage, onChangePage } = this.props
    const handlePageChange = (event: any, page: number) => {
      // Due to a bug of material UI, tables fire this callback on re-renders
      if (Boolean(event)) {
        onChangePage(page)
      }
    }
    // TODO: Wait for the real count from back
    const hardcodedCount = limit > people.length ? people.length : limit * (currentPage + 1) + 1
    return (
      <Paper elevation={2} className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <PersonRow header />
          </TableHead>
          <TableBody>
            {people.map((person) => {
              return <PersonRow key={person.id} person={person} onClick={() => selectPerson(person.id)} />
            })}
          </TableBody>
        </Table>
        <TablePagination
          count={hardcodedCount}
          rowsPerPage={limit}
          page={currentPage}
          rowsPerPageOptions={[]}
          backIconButtonProps={{
            'aria-label': 'Previous Page',
          }}
          nextIconButtonProps={{
            'aria-label': 'Next Page',
          }}
          onPageChange={handlePageChange}
        />
      </Paper>
    )
  }
}

export type PeopleTableProps = {
  people: Person[]
  currentPage: number
  limit: number
  search: string
  onChangePage: (nextPage: number) => void
  selectPerson: (personId?: number) => void
}

const mapStateToProps = (state: RootState): StateProps => {
  const people = getPeopleArray(state)
  const { currentPage, limit, search } = getSearchParams(state)
  return {
    currentPage,
    limit,
    search,
    people,
  }
}

const mapDispatchToProps = {
  selectPerson: openPersonForm,
  onChangePage: updateCurrentPage,
}

type StateProps = Omit<PeopleTableProps, 'selectPerson' | 'onChangePage'>

export default compose<PeopleTableProps & WithStyles<typeof styles>, {}>(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)(PeopleTable)
